export const SHOW_SIDEBAR = 'MENU/SHOW_SIDEBAR'
